import $axios from "../../api/axios";

function getPropertyDtlApi({ params, callback }) {
  if (!params.ordersId) {
    $axios
      .get(`/api/house/${params.id}/${params.roomId}/ordersId`)
      .then(res => {
        callback(res);
      })
      .catch(err => {
        console.log(err);
      });
  } else {
    $axios
      .get(`/api/house/${params.id}/${params.roomId}/${params.ordersId}`)
      .then(res => {
        callback(res);
      })
      .catch(err => {
        console.log(err);
      });
  }
}

function getPropertyRoomLstApi({ params, callback }) {
  $axios
    .get(`/api/houseRoomList/${params}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function submitInfo2Api({ params, callback }) {
  $axios
    .post(`/api/orders/reservation`, params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getTypeApi({ params, callback }) {
  console.log(params);
  $axios
    .get(`/api/cardType/${params.nums}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getSignUrlApi({ params, callback }) {
  $axios
    .post(`/api/signForUrl`, params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getPdfSizeApi({ params, callback }) {
  $axios
    .post(`/api/pdf/size`, params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getPropertyDtl2Api({ params, callback }) {
  let data = { passWord: params.password };
  if (params.publicFlag === 1) {
    data.publicFlag = 1;
  }
  if (params.roomId) {
    data.roomId = params.roomId;
  }
  $axios
    .post(`/api/housePublic/${params.id}`, data)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function shareApi({ params, callback }) {
  $axios
    .post(`/api/house/sharePasswd/email/${params.id}`, params.data)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getPropertyDtlApi,
  getPropertyRoomLstApi,
  getPropertyDtl2Api,
  submitInfo2Api,
  getTypeApi,
  getSignUrlApi,
  getPdfSizeApi,
  shareApi
};



// WEBPACK FOOTER //
// ./src/api/dtl/property.js